import React, { useContext, useEffect, useState } from 'react';
import { CustomChip, SkeletonLoader } from "components/shared";
import { BaseContainer, AttachementTemplate, TaskActionSet } from 'components/layout';
import { FolderService } from 'services/http';
import utils, { INNER_CONTAINER_HEIGHT } from 'utils';
import { useHistory } from 'react-router';
import { INTERVENTION_SOCKET_STATUS } from "utils"
import { TaskTagTemplate, TaskStatusTemplate } from "components/pages/client-management/client-history";
import { SocketContext } from 'services/';
import { LazyLoadingWithPagination } from 'components/shared';
import { useMemo } from 'react';

export const InterventionList = (props) => {

    let interventionSubscription;
    const socketContenxt = useContext(SocketContext);
    const history = useHistory();
    const [callback, setCallback] = useState();
    const [data, setData] = useState(props.data);

    useEffect(() => {
        //SUBSCRIBE INTERVENTIONS TOPIC
        socketContenxt.getStompClient().then((stomp) => {
            interventionSubscription = stomp.subscribe(`${process.env.REACT_APP_SOCKET_FOLDER_TOPIC}`, (data) => setCallback(JSON.parse(data.body)));
        });

        //UNSUBSCRIBE INTERVENTION TOPIC
        return () => { interventionSubscription && interventionSubscription.unsubscribe(); }
    }, []);

    //CALLBACK UPDATE FOR INTERVENTION BROADCAST
    useEffect(() => {
        const payload = callback;
        (payload && payload.type.includes(`intervention`)) &&
            onTendingDispatchedIntervention(payload);
    }, [callback]);

    //CALLBACK UPDATE FOR FETCHED INTERVENTIONS 
    useEffect(() => {
        props.callbackFn(props.data);
    }, [props.data.interventions]);

    //DEALING INTERVENTION BRAODCAST
    const onTendingDispatchedIntervention = (payload) => {
        if (payload) {
            let intervention = payload.intervention;
            switch (payload.type) {
                case INTERVENTION_SOCKET_STATUS.NEW_INTERVENTION_STATUS: {
                    //PUSH NEW INTERVENTION
                    if (data.interventions?.filter((item) => item.interventionId == intervention.interventionId).length < 1
                        && intervention.folder.folderId == props.folderId) {
                        //setInterventions({ ...interventions, data: utils.sortArrayObjectByDateDESC([...interventions.data, intervention], ["lastMessage", "sendDate"]) });
                        setData({ ...data, interventions: utils.sortArrayObjectByDateDESC([...data.interventions, intervention], ["lastMessage", "sendDate"]) })
                        utils.playAudioNotification();
                    }
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.UPDATED_INTERVENTION_STATUS: {
                    //UPDATING INTERVENTION
                    data.interventions && setData({
                        ...data, interventions: utils.sortArrayObjectByDateDESC(
                            data.interventions.map((item) => {
                                return item.interventionId === intervention.interventionId ? intervention : item;
                            }), ["lastMessage", "sendDate"])
                    });
                    //NOTIFY FOR UPDATED TASK STATUS
                    utils.getObjectFromSearchQuery(history, "task")?.interventionId == intervention.interventionId
                        && utils.pushURLSearchParams(history, "task", JSON.stringify(intervention));
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.REMOVED_INTERVENTION_STATUS: {
                    //DELETING INTERVENTION
                    data.interventions && setData({ ...data, interventions: data.interventions?.filter((item) => item.interventionId !== intervention.interventionId) });
                    if (utils.getObjectFromSearchQuery(history, "task")?.interventionId == intervention.interventionId) {
                        const queryParams = new URLSearchParams(history.location.search);
                        queryParams.delete("task");
                        history.replace({ search: queryParams.toString() });
                    }
                    break;
                }
                case INTERVENTION_SOCKET_STATUS.UPDATED_LAST_SEEN: {
                    //NOTIFY FOR UPDATED LAST SEEN
                    utils.getObjectFromSearchQuery(history, "task")?.interventionId == intervention.interventionId && utils.pushURLSearchParams(history, "task", JSON.stringify(intervention));
                    break;
                }
                default: {
                    break;
                }
            }

        }
    }


    return (
        <BaseContainer className={data.interventions?.length > 5 && 'container-scroll'} height={INNER_CONTAINER_HEIGHT}>
            {
                data.interventions.length ? data.interventions.map(intervention =>
                    <TaskItem
                        key={intervention.interventionId}
                        taskId={intervention.interventionId}
                        avatar={intervention.client.profilePic}
                        customerName={`${intervention.client.firstname} ${intervention.client.lastname}`}
                        message={intervention.lastMessage?.withAttachment === 1 ? <AttachementTemplate type={intervention.lastMessage.attachments[0].attachmentType} /> : utils.shorthandString(intervention.lastMessage.content)}
                        taskObject={intervention}
                        sourceIcon={utils.guessSourceIcon(intervention?.source.sourceId)}
                        time={new Date(intervention.creationDate).toLocaleString()} />)
                    : utils.NoItemsTemplate()
            }
            {
                props.children
            }
        </BaseContainer>
    );
}

//INTERVENTION-ITEM TEMPLATE
export const TaskItem = (props) => {

    const history = useHistory();

    const isCurrentItem = () => {
        let currentTask = JSON.parse(new URLSearchParams(history.location.search).get('task'));
        return currentTask?.interventionId === props.taskId;
    }

    return (
        <div className={`${isCurrentItem() && 'intervention-active'} folder-task-item d-flex w-100`}
            onClick={() => {
                utils.pushURLSearchParams(history, "task", JSON.stringify(props.taskObject));
            }}>
            <div className="text-justify mx-1 w-100">
                <div className="w-100 d-flex justify-content-between">
                    <CustomChip label={props.customerName} avatar={props.avatar} />
                    <span>
                        <TaskStatusTemplate status={props.taskObject.status} />&nbsp;
                        <small style={{ fontSize: "10px" }}> <i className="bi bi-clock-history" /> {props.time} &nbsp;</small>
                        <i className={`${props.sourceIcon} task-source-icon`} />
                    </span>
                </div>
                <div className="w-100 d-flex justify-content-between">
                    <small>{props.message}</small>
                    <div>
                        <span>
                            {
                                props.taskObject?.tags?.length > 0 &&
                                <div className="d-flex">
                                    <i className="bi bi-tag-fill mx-1" style={{ color: "#c3c3c3" }} />
                                    {
                                        props.taskObject.tags.map((tag) => {
                                            return (
                                                <TaskTagTemplate value={tag.description} color={`#${tag.color}`} />
                                            );
                                        })
                                    }
                                </div>
                            }
                        </span>
                        <TaskActionSet task={props.taskObject} />
                    </div>
                </div>
            </div>
        </div>
    )

}

//INTERVENTION-ITEMS WITH HIGH ORDER COMPONENT
export const InterventionListHoc = (props) => {

    const [folderSearchParamQuery, setFolderSearchParamQuery] = useState(``);
    let sortParam = new URLSearchParams(window.location.search).get('sort-by');

    //FILTER FOLDER INTERVENTIONS
    useEffect(() => {
        let folderSearch = JSON.parse(new URLSearchParams(window.location.search).get('folder-search'));
        if (folderSearch && utils.buildFilterCriteria(folderSearch)) {
            setFolderSearchParamQuery(utils.buildFilterCriteria(folderSearch));
        } else {
            props.folderId && setFolderSearchParamQuery(``);
        }
    }, [new URLSearchParams(window.location.search).get('folder-search')]);


    const InterventionHoc = useMemo(() => LazyLoadingWithPagination(InterventionList,
        FolderService.getLazyFolderInterventions, {
        folderId: props.folderId,
        pageIndex: 0,
        pageSize: 30,
        filterQuery: folderSearchParamQuery,
        sortBy: sortParam ? sortParam : ``
    }, "interventions", <SkeletonLoader factor={10} />)(props), [props.folderId, folderSearchParamQuery, new URLSearchParams(window.location.search).get('sort-by')]);
    return <InterventionHoc />
}
